namespace Areas.WebsiteInfo.Index {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("WebsiteInfo", "Index",
        ["Planning", "RFQ", "Story"]);


    export function websiteInfoTabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }
}